import { render, staticRenderFns } from "./LinksHandler.vue?vue&type=template&id=af5441d0&scoped=true"
import script from "./LinksHandler.vue?vue&type=script&lang=js"
export * from "./LinksHandler.vue?vue&type=script&lang=js"
import style0 from "./LinksHandler.vue?vue&type=style&index=0&id=af5441d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5441d0",
  null
  
)

export default component.exports